import { z } from "zod";

// Validação de CNPJ (aceita com ou sem formatação)
const cnpjValidation = z.string().refine(
  (val) => {
    const numbers = val.replace(/\D/g, '');
    return numbers.length === 14;
  },
  { message: "CNPJ deve conter 14 dígitos" }
);

// Validação de CEP (aceita com ou sem formatação)
const cepValidation = z.string().optional().refine(
  (val) => {
    if (!val) return true;
    const numbers = val.replace(/\D/g, '');
    return numbers.length === 0 || numbers.length === 8;
  },
  { message: "CEP deve conter 8 dígitos" }
);

// Schema para criação de empresa
export const companySchema = z.object({
  // Dados da Empresa
  razao_social: z.string().min(3, "Razão Social deve ter pelo menos 3 caracteres"),
  nome_fantasia: z.string().min(3, "Nome Fantasia deve ter pelo menos 3 caracteres"),
  cnpj: cnpjValidation,
  area_atuacao: z.string().min(3, "Área de Atuação é obrigatória"),
  ativo: z.boolean().default(true),
  
  // Endereço (opcional)
  rua: z.string().optional(),
  cidade: z.string().optional(),
  uf: z.string().length(2, "UF deve ter 2 caracteres").optional().or(z.literal("")),
  cep: cepValidation,
  
  // Dados do Usuário Admin (obrigatórios)
  admin_nome: z.string().min(3, "Nome do administrador deve ter pelo menos 3 caracteres"),
  admin_email: z.string().email("Email inválido"),
  admin_senha: z.string().min(8, "Senha deve ter pelo menos 8 caracteres"),
  
  // Plano de Assinatura (opcional)
  criar_assinatura: z.boolean().default(false),
  plano_id: z.number().optional(),
}).refine((data) => {
  if (data.criar_assinatura) {
    return data.plano_id;
  }
  return true;
}, {
  message: "Plano é obrigatório quando 'Criar assinatura' está marcado",
  path: ["plano_id"],
});

// Schema para edição de empresa (sem campos de admin e assinatura)
export const companyEditSchema = z.object({
  razao_social: z.string().min(3, "Razão Social deve ter pelo menos 3 caracteres"),
  nome_fantasia: z.string().min(3, "Nome Fantasia deve ter pelo menos 3 caracteres"),
  cnpj: cnpjValidation,
  area_atuacao: z.string().min(3, "Área de Atuação é obrigatória"),
  ativo: z.boolean().default(true),
  rua: z.string().optional(),
  cidade: z.string().optional(),
  uf: z.string().length(2, "UF deve ter 2 caracteres").optional().or(z.literal("")),
  cep: cepValidation,
});

export type CompanyFormData = z.infer<typeof companySchema>;
export type CompanyEditFormData = z.infer<typeof companyEditSchema>;
